/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-28 16:39:53 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-27 17:30:21
 */

<template>
  <div class="registered">
    <div class="content">
      <a-form :model="filter">
        <a-row
          class="search"
          :gutter="60"
        >
          <a-col :span="6">
            <a-form-item label="Name">
              <a-input
                v-model:value="filter.name"
                placeholder="Please enter"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="Email">
              <a-input
                v-model:value="filter.email"
                placeholder="Please enter"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="Apply Time">
              <a-range-picker
                v-model:value="filterDate"
                :style="{ width: '220px' }"
                format="YYYY-MM-DD"
                :allow-clear="true"
                :placeholder="['Start date', 'End date']"
                @change="setFilterDate"
              />
            </a-form-item>
          </a-col>
          <a-col
            :span="6"
            class="btns"
          >
            <a-button
              type="primary"
              @click="onSearch"
            >
              Search
            </a-button>
            <a-button @click="resetSearch">
              Reset
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div
      v-if="search.total"
      class="filter"
    >
      <a-checkbox
        v-model:checked="selectedList.checkAll"
        :indeterminate="selectedList.indeterminate"
        @change="(e) => toggleSelect(e, 'all')"
      >
        Select All
      </a-checkbox>
      <a-button
        v-if="reviewStatus === 'pending' || reviewStatus === 'rejected'"
        size="small"
        type="primary"
        :disabled="!selectedList.list.length"
        @click="confirmReviewStatus(null, 'Approved')"
      >
        Approve
      </a-button>
      <a-button
        v-if="
          (reviewStatus === 'approved' || reviewStatus === 'pending') &&
            !selectedList.list.length
        "
        size="small"
        disabled
      >
        Reject
      </a-button>
      <a-popconfirm
        v-else-if="
          (reviewStatus === 'approved' || reviewStatus === 'pending') &&
            selectedList.list.length
        "
        title="Are you sure to reject this application?"
        ok-text="Yes"
        cancel-text="No"
        @confirm="confirmReviewStatus(null, 'Rejected')"
      >
        <a-button
          size="small"
          danger
        >
          Reject
        </a-button>
      </a-popconfirm>
    </div>
    <div
      v-if="search.total"
      class="list"
    >
      <div
        v-for="(influencer, index) in data"
        :key="influencer.id"
        class="item"
      >
        <div class="top-info">
          <div class="left">
            <a-checkbox
              :checked="selectedList.list.indexOf(influencer.id) != -1"
              @change="(e) => toggleSelect(e, influencer.id)"
            />
            <span
              class="influencer-id"
            >UserID: {{ influencer.id }}</span>
            <span
              class="apply-time"
            >Apply Time:
              {{
                moment(influencer.applyTime).format('YYYY-MM-DD HH:mm:ss')
              }}</span>
            <span
              v-if="reviewStatus != 'pending'"
              class="update-time"
            >Update Time:
              {{
                moment(influencer.updateTime).format('YYYY-MM-DD HH:mm:ss')
              }}</span>
          </div>
          <div class="right">
            Status: {{ influencer.reviewStatus }}
          </div>
        </div>
        <div class="detail-info">
          <div class="left">
            <h3>User Infomation</h3>
            <div class="flex-wrapper">
              <div class="flex-left">
                <p
                  class="email"
                  :title="influencer.email"
                >
                  Email: {{ influencer.email }}
                </p>
                <p :title="influencer.name">
                  Name: {{ influencer.name }}
                </p>
              </div>
              <div class="flex-right note">
                <p>Note:</p>
                <p class="influencer-note-pre">
                  {{ influencer.note }}
                </p>
              </div>
            </div>
            <h3 class="mt10">
              Social Platform
            </h3>
            <div
              v-if="reviewStatus === 'approved'"
              class="flex-wrapper"
            >
              <div
                v-for="(platform, platformIdx) in influencer.socialPlatforms"
                :key="platformIdx"
                class="social-platform-item"
                :title="platform.platformName + ': ' + platform.homepage"
              >
                <div class="ellipsis-wrapper multiple3">
                  {{ platform.platformName }}: {{ platform.homepage }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex-wrapper"
            >
              <div
                v-for="(platform, platformIdx) in influencer.socialPlatforms"
                :key="platformIdx"
                class="social-platform-item editable"
              >
                <a-select
                  :options="socialPlatforms"
                  :value="platform.platformId"
                  :dropdown-match-select-width="false"
                  @change="
                    (value) =>
                      setSocialPlatformInfo(
                        platform.id,
                        'platformId',
                        value,
                        platform,
                        influencer
                      )
                  "
                />
                <SocialHomepageInput
                  :ref="(el) => setHomepageInputRef(influencer.id, platform, el)"
                  :model-value="platform.homepage"
                  :placeholder="getHomepagePlaceholder(platform)"
                  @commit="
                    (value) =>
                      setSocialPlatformInfo(
                        platform.id,
                        'homepage',
                        value,
                        platform
                      )
                  "
                />
              </div>
            </div>
            <div
              v-if="influencer.invitationCode"
              class="invitation-code"
            >
              Invitation Code:
              {{ influencer.invitationCode }}(Unregistered)<CopyOutlined
                @click="setClipboardText(influencer.invitationCode)"
              />
            </div>
          </div>
          <div class="right">
            <a-textarea
              v-model:value="influencer.operatorRemark"
              placeholder="Remark: Click to enter"
              @blur="(e) => saveRemark(e, index, influencer.id)"
              @pressEnter.prevent="(e) => saveRemark(e, index, influencer.id)"
            />
            <div
              v-if="influencer.ipDesc"
              class="mt20"
            >
              IP: {{ influencer.ipDesc }}
            </div>
            <div class="link-tool mt20">
              Link Tool:
              <a-switch
                v-model:checked="influencer.linkToolStatus"
                checked-children="ON"
                un-checked-children="OFF"
                @click="emit('toggleStatus', index, influencer)"
              />
            </div>
            <div class="actions mt20">
              <a-button
                v-if="reviewStatus === 'rejected' || reviewStatus === 'pending'"
                type="primary"
                @click="confirmReviewStatus(influencer.id, 'Approved')"
              >
                Approve
              </a-button>
              <a-popconfirm
                v-if="reviewStatus === 'approved' || reviewStatus === 'pending'"
                title="Are you sure to reject this application?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="confirmReviewStatus(influencer.id, 'Rejected')"
              >
                <a-button danger>
                  Reject
                </a-button>
              </a-popconfirm>
              <a-button
                @click="emit('setShowLogModalId', influencer.id)"
              >
                Log
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="list no-data"
    >
      No Data.
    </div>
    <a-pagination
      v-if="search.total > search.size"
      v-model:current="search.page"
      class="pagination"
      :page-size="search.size"
      :total="search.total"
      show-less-items
      @change="setPage"
    />
  </div>
</template>

<script setup>
import moment from 'moment'
import { message } from 'ant-design-vue'
import { ref, reactive } from 'vue'
import { CopyOutlined } from '@ant-design/icons-vue'
import { influencers } from '../../server'
import SocialHomepageInput from './SocialHomepageInput.vue'

const reviewStatus = location.hash.replace(/^#\/[\w\W]*?\/([\w\W]*)$/, '$1')
const initialFilters = {
  id: null,
  page: 1,
  size: 200,
  total: 0,
  name: null,
  email: null,
  applyEndTime: null,
  applyBeginTime: null,
  reviewStatus:
    reviewStatus.charAt(0).toUpperCase() + reviewStatus.substring(1),
}
let search = reactive({ ...initialFilters })
let filter = reactive({ ...initialFilters })
const socialPlatforms = ref([])
const selectedList = reactive({
  list: [],
  checkAll: false,
  indeterminate: false,
})
const filterDate = ref([null, null])
const props = defineProps({
  data: { type: Array, default: () => [] },
})
const emit = defineEmits([
  'getList',
  'setLoading',
  'toggleStatus',
  'setShowLogModalId',
  'changeReviewStatus',
])

emit('getList', search, (res) => {
  if (search.page == 1) {
    search.total = res.total
  }
})

influencers.getSocialPlatformsList().then((res) => {
  socialPlatforms.value = res.data.map((inner) => {
    return {
      ...inner,
      label: inner.name,
      value: inner.id,
    }
  })
})

function setFilterDate(values) {
  filter.applyEndTime = values[1].endOf('date').valueOf()
  filter.applyBeginTime = values[0].startOf('date').valueOf()
}

function onSearch() {
  Object.assign(search, {
    ...filter,
    page: 1,
  })
  setPage(1)
}

function resetSearch() {
  Object.assign(search, initialFilters)
  Object.assign(filter, initialFilters)
  filterDate.value = [null, null]
  setPage(1)
}

function setClipboardText(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then((error) => {
      if (error) {
        message.error(error)
      } else {
        message.success('Copied')
      }
    })
  } else {
    message.warn(
      'Your brower version is too old, please update before use copy function.'
    )
  }
}

function getPlatformKey(platform) {
  return String(
    platform?.platformName || platform?.name || platform?.label || ''
  )
    .trim()
    .toLowerCase()
    .replace(/\.$/, '')
}

const HOMEPAGE_PLACEHOLDER_MAP = {
  instagram: 'e.g. www.instagram.com/xxx',
  youtube: 'e.g. www.youtube.com/@xxx',
  linktree: 'e.g. linktr.ee/xxx',
  facebook: 'e.g. www.facebook.com/xxx',
  x: 'e.g. x.com/xxx',
  twitter: 'e.g. x.com/xxx',
  tiktok: 'e.g. www.tiktok.com/@xxx',
  red: 'e.g. xhslink.com/xxx',
  xiaohongshu: 'e.g. xhslink.com/xxx',
  wechat: 'wechat username',
  weibo: 'e.g. weibo.com/xxx',
  blog: 'Please fill in URL',
  website: 'Please fill in URL',
  others: 'Please fill in URL',
  other: 'Please fill in URL',
}

const HOMEPAGE_DOMAIN_MAP = {
  instagram: ['instagram.com'],
  youtube: ['youtube.com'],
  linktree: ['linktr.ee'],
  facebook: ['facebook.com'],
  x: ['x.com'],
  twitter: ['x.com'],
  tiktok: ['tiktok.com'],
  red: ['xhslink.com', 'xhslink.cn'],
  xiaohongshu: ['xhslink.com', 'xhslink.cn'],
  weibo: ['weibo.com'],
}
const HOMEPAGE_URL_FORMAT_KEYS = new Set(['blog', 'website', 'others', 'other'])
const HOMEPAGE_SKIP_VALIDATE_KEYS = new Set(['wechat'])

function isValidUrlFormat(val) {
  const input = String(val).trim().replace(/^https?:\/\//i, '')
  return /^[\w-]+(\.[\w-]+)+([/?#][^\s]*)?$/i.test(input)
}

function getHomepagePlaceholder(platform) {
  const name = getPlatformKey(platform)
  if (!name) return 'URL or Username'
  return HOMEPAGE_PLACEHOLDER_MAP[name] || 'Please fill in URL'
}

function getHomepageValidationHelp(val, platform) {
  const key = getPlatformKey(platform)
  if (!key || HOMEPAGE_SKIP_VALIDATE_KEYS.has(key)) return ''

  if (HOMEPAGE_URL_FORMAT_KEYS.has(key) && !isValidUrlFormat(val)) {
    return 'Please enter a valid URL'
  }

  const domains = HOMEPAGE_DOMAIN_MAP[key]
  if (domains) {
    const lower = String(val).toLowerCase()
    if (!domains.some((domain) => lower.includes(domain))) {
      return 'Please enter a valid social media link, or select "Others" as the link type.'
    }
  }

  return ''
}

const homepageInputRefs = new Map()

function homepageInputKey(influencerId, platform) {
  return `${influencerId}-${platform.id || platform.platformId}`
}

function setHomepageInputRef(influencerId, platform, el) {
  const key = homepageInputKey(influencerId, platform)
  if (el) {
    homepageInputRefs.set(key, el)
  } else {
    homepageInputRefs.delete(key)
  }
}

function getPlatformHomepageValue(influencer, platform) {
  const key = homepageInputKey(influencer.id, platform)
  const input = homepageInputRefs.get(key)
  if (input?.getValue) {
    return input.getValue()
  }
  return String(platform.homepage || '').trim()
}

function validateInfluencerPlatforms(influencer) {
  const platforms = influencer?.socialPlatforms || []
  if (!platforms.length) {
    return 'Please enter the homepage'
  }
  for (const platform of platforms) {
    const homepage = getPlatformHomepageValue(influencer, platform)
    if (!homepage) {
      return 'Please enter the homepage'
    }
    const help = getHomepageValidationHelp(homepage, platform)
    if (help) return help
  }
  return ''
}

function syncInfluencerHomepages(influencer) {
  const platforms = influencer.socialPlatforms || []
  platforms.forEach((platform) => {
    const value = getPlatformHomepageValue(influencer, platform)
    if (value !== String(platform.homepage || '').trim()) {
      setSocialPlatformInfo(platform.id, 'homepage', value, platform)
    }
  })
}

function confirmReviewStatus(id, status) {
  const ids = id ? [id] : selectedList.list
  const targets = props.data.filter((item) => ids.includes(item.id))
  for (const influencer of targets) {
    const help = validateInfluencerPlatforms(influencer)
    if (help) {
      message.error(
        targets.length > 1 ? `UserID ${influencer.id}: ${help}` : help
      )
      return
    }
  }
  targets.forEach(syncInfluencerHomepages)
  changeReviewStatus(id, status)
}

function setSocialPlatformInfo(id, type, value, platform, influencer) {
  value = ('' + value).trim()

  if (type === 'platformId' && platform) {
    if (!value.length) return
    const nextPlatformId = Number(value) || value
    const found = socialPlatforms.value.find(
      (item) => item.value === nextPlatformId
    )
    const nextPlatformName = found?.label || found?.name || platform.platformName
    const homepage = influencer
      ? getPlatformHomepageValue(influencer, platform)
      : String(platform.homepage || '').trim()

    // 先切换平台（不拦选择）；有 homepage 时再提示是否符合新平台规则
    platform.platformId = nextPlatformId
    platform.platformName = nextPlatformName
    if (homepage) {
      const help = getHomepageValidationHelp(homepage, platform)
      if (help) {
        message.error(help)
      }
    }
    influencers.setSocialPlatformInfo(id, type, value).catch(() => {
      message.error('Save failed, please try again.')
    })
    return
  }

  if (type === 'homepage') {
    if (!value.length) {
      message.error('Please enter the homepage')
      return
    }
    const help = getHomepageValidationHelp(value, platform)
    if (help) {
      message.error(help)
      return
    }
    if (value === String(platform.homepage || '').trim()) {
      return
    }
    platform.homepage = value
    influencers.setSocialPlatformInfo(id, type, value).catch(() => {
      message.error('Save failed, please try again.')
    })
  }
}

// 状态变更后都取第一页数据
function changeReviewStatus(id, status) {
  emit('setLoading', true)
  emit('changeReviewStatus', id ? [id] : selectedList.list, status, (res) => {
    if (res.success) {
      search.page = 1
      emit('getList', search, (res) => {
        const ids = res.data.map((item) => item.id)

        search.total = res.total

        selectedList.list = selectedList.list.filter(
          (id) => ids.indexOf(id) != -1
        )

        if (selectedList.list.length) {
          selectedList.checkAll = selectedList.list.length === ids.length
          selectedList.indeterminate = selectedList.list.length !== ids.length
        } else {
          selectedList.checkAll = false
          selectedList.indeterminate = false
        }
      })
    } else {
      emit('setLoading', false)
    }
  })
}

function saveRemark(event, index, id) {
  const remark = event.target.value.trim()

  if (remark.length) {
    emit('setLoading', true)
    influencers
      .saveRemark({
        id,
        operatorRemark: remark,
      })
      .then((res) => {
        emit('setLoading', false)
        if (!res.success) {
          message.error('Failed to add remark, please try again later.')
        }
      })
  }
}

function toggleSelect(e, id) {
  if (e.target.checked) {
    if (id === 'all') {
      selectedList.list = props.data.map((item) => item.id)
    } else {
      selectedList.list = [...selectedList.list, id]
    }
  } else {
    if (id === 'all') {
      selectedList.list = []
    } else {
      selectedList.list = selectedList.list.filter(
        (selectedId) => selectedId != id
      )
    }
  }

  if (selectedList.list.length) {
    selectedList.checkAll = selectedList.list.length === props.data.length
    selectedList.indeterminate = selectedList.list.length !== props.data.length
  } else {
    selectedList.checkAll = false
    selectedList.indeterminate = false
  }
}

function setPage(page) {
  search.page = page
  emit('getList', search, (res) => {
    if (page == 1) {
      search.total = res.total
    }
  })
}
</script>

<style lang="less" scoped>
@import '../../assets/less/common.less';

.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.multiple3 {
  max-height: 66px;
  .multiple-ellipsis(3);
}
.search {
  margin-right: -20px !important;
  .btns {
    padding-right: 20px !important;
  }
}
.filter {
  margin-left: 10px;
  margin-bottom: 10px;
  :deep(.ant) {
    &-checkbox-wrapper {
      margin-right: 20px;
    }
    &-checkbox + span {
      padding-left: 4px;
    }
    &-btn {
      margin-right: 10px;
    }
  }
}
.list {
  .item {
    border-radius: 6px;
    margin-bottom: 20px;
    background: #fff;
    padding: 10px 10px 20px;
    border: 1px solid #d9d9d9;
  }
  h3 {
    margin: 0 0 10px;
    &.mt10 {
      margin-top: 10px;
    }
  }
  .top-info {
    display: flex;
    margin: 0 -10px;
    align-items: center;
    padding: 0 10px 10px;
    justify-content: space-between;
    border-bottom: 1px solid #d9d9d9;
    > .right {
      width: 240px;
      margin-left: 15px;
    }
  }
  .left {
    P {
      margin: 0;
      max-width: 100%;
      word-break: break-all;
    }
    > * {
      margin-right: 40px;
    }
    :deep(.ant-checkbox) {
      &-wrapper {
        margin-right: 4px;
      }
    }
    .influencer-id {
      width: 150px;
      margin-right: 0;
      display: inline-block;
    }
    .apply-time,
    .update-time {
      width: 240px;
      margin-right: 40px;
      display: inline-block;
    }
    .update-time {
      margin-right: 0;
    }
    .flex-wrapper {
      display: flex;
      margin-right: 0;
      justify-content: space-between;
      > div {
        flex: 1;
        &.flex-left {
          flex: 1;
          margin: 0 20px;
        }
      }
      .email {
        margin-bottom: 10px;
      }
      .note {
        flex: 1;
        display: flex;
        overflow: hidden;
        margin-right: 20px;
        word-break: break-all;
        > p:first-of-type {
          margin-right: 5px;
          white-space: nowrap;
        }
        .influencer-note-pre {
          margin: 0;
          flex: 1;
          white-space: pre-wrap;
        }
      }
    }
  }
  .detail-info {
    display: flex;
    margin-top: 15px;
    padding-left: 10px;
    .left {
      flex: 1;
      width: calc(100% - 261px);
    }
    .right {
      flex: 0 0 240px;
      padding: 15px 15px 5px;
      background: #f2f2f2;
      margin: -15px -10px -20px 0;
      border-bottom-right-radius: 6px;
      border-left: 1px solid #d9d9d9;
    }
    .actions {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      :deep(.ant) {
        &-btn {
          margin-right: 10px;
          margin-bottom: 10px;
          flex: 0 0 calc(50% - 5px);
          &:nth-child(even) {
            margin-right: 0;
          }
        }
      }
    }
    .link-tool {
      display: flex;
      align-items: center;
      :deep(.ant-switch) {
        margin-left: 4px;
      }
    }
  }
  .social-platform-item {
    padding: 10px;
    border-radius: 6px;
    word-break: break-all;
    background: #f2f2f2;
    &.editable {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    > div {
      word-break: break-all;
    }
    &:first-of-type {
      margin: 0 20px;
      max-width: calc(50% - 40px);
    }
    :deep(.ant) {
      &-select-selector {
        border: none;
        box-shadow: none !important;
        background-color: transparent;
      }
    }
  }
  .invitation-code {
    margin-top: 15px;
  }
}
.no-data {
  font-size: 40px;
  color: #999;
  margin-top: 200px;
  text-align: center;
}
.pagination {
  text-align: right;
  margin-bottom: 20px;
}
</style>